export default __webpack_public_path__ + "static/media/logo.a3b27196.png";